import { useQuery } from "@tanstack/react-query";

import {
  IProtocolResponse,
  IPatientProtocolAction,
} from "../../@types/Protocol";
import { protocolService } from "../../services/protocol.service";

export function useProtocols() {
  const { data, isError, isFetching, refetch, isRefetching } = useQuery<
    IProtocolResponse[]
  >({
    queryKey: ["protocols-list"],
    queryFn: async () => {
      const { data } = await protocolService.getProtocolList();

      return data;
    },
    refetchOnMount: "always",
  });

  return {
    protocols: data as IProtocolResponse[],
    isFetching,
    isError,
    refetch,
    isRefetching,
  };
}

// EN-3346: the protocol actions assigned to a patient. Returns an empty array
// (rather than undefined) so consumers can safely read `.length` before the
// query settles.
export function usePatientProtocolActions(patientId: number | undefined) {
  const { data, isError, isFetching, isFetched, refetch, isRefetching } =
    useQuery<IPatientProtocolAction[]>({
      queryKey: [`patient-protocol-actions-${patientId}`, patientId],
      queryFn: async () => {
        if (!patientId) return [];

        const { data } = await protocolService.getPatientActions(
          patientId.toString()
        );

        return data ?? [];
      },
      enabled: !!patientId,
    });

  return {
    protocolActions: (data as IPatientProtocolAction[]) ?? [],
    isFetching,
    isFetched,
    isError,
    refetch,
    isRefetching,
  };
}
